import { render, staticRenderFns } from "./interestPoint.vue?vue&type=template&id=96c93698&scoped=true&"
import script from "./interestPoint.vue?vue&type=script&lang=js&"
export * from "./interestPoint.vue?vue&type=script&lang=js&"
import style0 from "./interestPoint.vue?vue&type=style&index=0&id=96c93698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c93698",
  null
  
)

export default component.exports